// @file Slug → human-readable label for Arcade generation types.
// Fallback for attached posts created before the label was persisted.

import { __ } from '@@/bits/intl'

const ARCADE_GAME_TYPE_LABELS = {
  'activity-ideas': __('Activity ideas'),
  'class-activities': __('Class activities'),
  'coloring-sheet': __('Coloring sheet'),
  crossword: __('Crossword'),
  curriculum: __('Curriculum'),
  'decodable-book': __('Decodable book'),
  'fill-in-the-blank': __('Fill in the blank'),
  flashcards: __('Flashcards'),
  // Canonical Arcade share links use a generic `/game/<id>` path with no specific activity
  // type, so the parsed type is the bare slug "game". Map it to a friendly label.
  game: __('Arcade game'),
  grading: __('Grading'),
  'image-generator': __('Image generator'),
  'lesson-plan': __('Lesson plan'),
  matching: __('Matching'),
  'memory-tiles': __('Memory tiles'),
  'multimedia-presentation': __('Multimedia presentation'),
  'multiple-choice-quiz': __('Multiple choice'),
  'multiple-choice-v2': __('Multiple choice'),
  'name-picker': __('Name picker'),
  presentation: __('Presentation'),
  'procedural-text': __('Procedural text'),
  'qr-code-generator': __('QR code generator'),
  'reading-passage': __('Reading passage'),
  rubric: __('Rubric'),
  sequencing: __('Sequencing'),
  'short-answer': __('Short answer'),
  'short-link': __('Short link'),
  'short-story': __('Short story'),
  'smart-groups': __('Smart groups'),
  sorting: __('Sorting'),
  studio: __('Wildcard'),
  'text-leveler': __('Text leveler'),
  'text-translator': __('Text translator'),
  'tracing-sheet': __('Tracing sheet'),
  'word-problem': __('Word problem'),
  'word-search': __('Word search'),
  worksheet: __('Worksheet'),
} satisfies Record<string, string>

type ArcadeGameType = keyof typeof ARCADE_GAME_TYPE_LABELS

function getArcadeGameTypeLabel(slug: string | null | undefined): string {
  if (slug == null || slug === '') return ''
  return ARCADE_GAME_TYPE_LABELS[slug as ArcadeGameType] ?? slug
}

export { getArcadeGameTypeLabel }
export type { ArcadeGameType }
